import { useState, useEffect } from 'react';
export const usePrefersReducedMotion = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
    useEffect(() => {
        const reducedMotionMediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        setPrefersReducedMotion(reducedMotionMediaQueryList.matches);
        const mediaQueryListener = () => {
            setPrefersReducedMotion(reducedMotionMediaQueryList.matches);
        };
        try {
            if (!(reducedMotionMediaQueryList === null || reducedMotionMediaQueryList === void 0 ? void 0 : reducedMotionMediaQueryList.addEventListener))
                return;
            reducedMotionMediaQueryList.addEventListener('change', mediaQueryListener);
        }
        catch (error) {
            console.error('reducedMotionMediaQueryList.addEventListener is not supported');
        }
        return () => {
            try {
                if (!(reducedMotionMediaQueryList === null || reducedMotionMediaQueryList === void 0 ? void 0 : reducedMotionMediaQueryList.removeEventListener))
                    return;
                reducedMotionMediaQueryList === null || reducedMotionMediaQueryList === void 0 ? void 0 : reducedMotionMediaQueryList.removeEventListener('change', mediaQueryListener);
            }
            catch (error) {
                console.error('reducedMotionMediaQueryList.removeEventListener is not supported');
            }
        };
    }, []);
    return prefersReducedMotion;
};
